import { useEffect, useState } from 'react';

import fleetApi from '../../services/api.service';

/**
 * Les véhicules du jour, jour par jour (GET /vehicles/eligible) : éligibles,
 * indisponibles ce jour avec leur motif, et retirés depuis leur fiche.
 *
 * Même hook que sur tms-chargeur (src/api/vehicles/useGetEligibleVehicles.js).
 * Un appel par jour demandé, en parallèle. Les réponses sont rangées sous la
 * clé des jours qu'elles décrivent : celles d'une autre date ne s'affichent
 * jamais, même le temps que les nouvelles arrivent. Un jour dont la lecture
 * échoue vaut null.
 *
 * @param {object} params - Les paramètres
 * @param {Array<string>} [params.dates] - Les jours (YYYY-MM-DD). Sans jour, aucun appel.
 * @param {*} [params.refreshKey] - Change à chaque rechargement voulu
 * @returns {object} - { byDate: { [date]: réponse|null }, isLoading }
 */
export default function useGetEligibleVehicles({ dates, refreshKey } = {}) {
  const [result, setResult] = useState({ key: null, byDate: {} });

  // La liste change d'identité à chaque rendu : c'est son contenu qui compte.
  const key = (dates || []).join(',') || null;

  useEffect(() => {
    if (!key) return undefined;

    let isActive = true;

    const load = async () => {
      const entries = await Promise.all(
        key.split(',').map(async (date) => {
          try {
            const response = await fleetApi.get(
              `/vehicles/eligible?${new URLSearchParams({ date }).toString()}`
            );

            return [date, response.data];
          } catch {
            return [date, null];
          }
        })
      );

      if (isActive) setResult({ key, byDate: Object.fromEntries(entries) });
    };

    load();

    return () => {
      isActive = false;
    };
  }, [key, refreshKey]);

  return {
    byDate: result.key === key ? result.byDate : {},
    isLoading: result.key !== key,
  };
}
